import React, { useState } from 'react';
import classnames from 'classnames';

import BaseRealTimeCheckingInput from '../BaseRealTimeCheckingInput';
import useRules from './hooks/useRules';

type Props = React.ComponentProps<typeof BaseRealTimeCheckingInput> & {
    inputClassName?: string;
    isNewPassword?: boolean;
    hasEyeButton?: boolean;
    shouldShowRulesWhenEmpty?: boolean;
};

const BasePasswordInput: React.FC<Props> = (props) => {
    const rules = useRules();
    const [shouldShowPassword, setShouldShowPassword] = useState(false);

    const inputClassName = classnames('password-input', props.inputClassName);
    const inputType = shouldShowPassword ? 'text' : 'password';
    const autoComplete = props.isNewPassword ? 'new-password' : 'on';
    const eyeButton = {
        icon: shouldShowPassword ? 'icon-btn_show_pw' : 'icon-btn_hide_pw',
        onClick: () => setShouldShowPassword(!shouldShowPassword),
    };

    return (
        <div className={classnames('password-input-container', props.className)}>
            <BaseRealTimeCheckingInput
                {...props}
                name={props.isNewPassword ? 'new-password' : 'password'}
                className={inputClassName}
                rules={props.isNewPassword ? rules : []}
                type={inputType}
                autoComplete={autoComplete}
                button={props.hasEyeButton && eyeButton}
                shouldShowRulesWhenEmpty={props.shouldShowRulesWhenEmpty}
            />
        </div>
    );
};

BasePasswordInput.defaultProps = {
    hasEyeButton: true,
};

export default BasePasswordInput;
